import { GridColDef } from '@mui/x-data-grid-pro'
import { Avatar } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import IconButton from '@/shared/components/IconButton/IconButton'
import styles from '../DeviceColumns.module.scss'

export const useDeviceColumnsConfig = (
  handleOnDelete?: (id: string) => void,
  handleOnEdit?: (id: string) => void
) => {
  const { t } = useTranslation()
  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'deviceType',
        headerName: t('TABLE.DEVICES.HEADERS.DEVICE'),
        editable: false,
        hideable: false,
        headerClassName: styles.tableHeader,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        flex: 1,
        minWidth: 160,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        ),
        renderCell: params => (
          <div className={styles.deviceCell}>
            <i className={`${params.row.deviceIcon} icon-medium`} />
            <span>{params.value}</span>
          </div>
        )
      },
      {
        field: 'users',
        headerName: t('TABLE.DEVICES.HEADERS.USERS'),
        editable: false,
        headerClassName: styles.tableHeader,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        flex: 1,
        minWidth: 160,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        ),
        renderCell: params => (
          <div className={styles.userCell}>
            <Avatar
              src={params.row.userAvatar}
              alt={params.value}
              sx={{ width: '2rem', height: '2rem' }}
            >
              <i className="las la-user" />
            </Avatar>
            <span>{params.value}</span>
          </div>
        )
      },
      {
        field: 'date',
        headerName: t('TABLE.DEVICES.HEADERS.DATE'),
        editable: false,
        headerClassName: styles.tableHeader,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        flex: 1,
        minWidth: 120,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        )
      },
      {
        field: 'action',
        headerName: '',
        resizable: false,
        editable: false,
        headerClassName: styles.tableHeader,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        disableReorder: true,
        sortable: false,
        pinnable: true,
        hideable: false,
        width: 80,
        minWidth: 80,
        maxWidth: 80,
        renderHeader: params => (
          <p
            className={`${styles.tableHeaderText} body-bold-medium hideRightSeparator`}
          >
            {params.colDef.headerName}
          </p>
        ),
        renderCell: params => (
          <div className={styles.tableActionContainer}>
            <IconButton
              icon="las la-edit icon-medium"
              onClick={() => handleOnEdit?.(params.row.id)}
              color="primary"
            />
            <IconButton
              icon="las la-trash icon-medium"
              onClick={() => handleOnDelete?.(params.row.id)}
              color="primary"
            />
          </div>
        )
      }
    ],
    [handleOnDelete, handleOnEdit, t]
  )
  return columns
}
